import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import { AuthProvider } from "@/lib/auth";
import { MediaPlayerProvider, PersistentMediaElements } from "@/lib/mediaPlayer";
import useTraffic from "@/lib/useTraffic";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import MiniPlayer from "@/components/MiniPlayer";
import WelcomeSplash from "@/components/WelcomeSplash";
import ShareMenu from "@/components/ShareMenu";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/Home";
import Connect from "@/pages/Connect";
import AuthCallback from "@/pages/AuthCallback";
import Admin from "@/pages/Admin";
import Gallery from "@/pages/Gallery";
import Music from "@/pages/Music";
import Gaming from "@/pages/Gaming";
import Artists from "@/pages/Artists";
import ArtistDetail from "@/pages/ArtistDetail";
import Videos from "@/pages/Videos";
import About from "@/pages/About";
import SignIn from "@/pages/SignIn";
import Creator from "@/pages/Creator";

function AppRouter() {
  const location = useLocation();
  useTraffic();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Nav />
      <main className="min-h-[60vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/connect" element={<Connect />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/music" element={<Music />} />
          <Route path="/gaming" element={<Gaming />} />
          <Route path="/artists" element={<Artists />} />
          <Route path="/artists/:slug" element={<ArtistDetail />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/about" element={<About />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/creator" element={<Creator />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <PersistentMediaElements />
      <MiniPlayer />
      <WelcomeSplash />
      <ShareMenu />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <MediaPlayerProvider>
              <Toaster theme="dark" position="top-right" toastOptions={{ style: { borderRadius: 0, border: "1px solid #333" } }} />
              <AppRouter />
            </MediaPlayerProvider>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
